// Update number of slides in the screenreadertext
function updateScreenReaderText(splide, splideElement) {
    var screenReaderText = splideElement.querySelector('.live_region');
    var dataScreenreaderTextPostType =
        screenReaderText.getAttribute('data-label-showing');

    splide.on('moved', function () {
        var currentSlide = splide.index + 1;
        var totalSlides = splide.length;
        screenReaderText.textContent =
            dataScreenreaderTextPostType +
            ' ' +
            currentSlide +
            ' / ' +
            totalSlides;
    });
}

document.addEventListener('DOMContentLoaded', function () {
    var splideElements = document.querySelectorAll('.image_carousel');

    splideElements.forEach(function (splideElement) {
        var carouselCardSettings = {
            type: 'loop',
            perPage: 1,
            pagination: false,
            arrows: true,
            autoplay: false,
            interval: 3000,
            pauseOnHover: true,
            i18n: {
                prev: splideElement.getAttribute('prev-slide'),
                next: splideElement.getAttribute('next-slide'),
                first: splideElement.getAttribute('first-slide'),
                last: splideElement.getAttribute('last-slide'),
                slideX: splideElement.getAttribute('slideX-slide'),
                pageX: splideElement.getAttribute('pageX-slide'),
                carousel: splideElement.getAttribute('carousel-slide'),
                select: splideElement.getAttribute('select-slide'),
                slide: splideElement.getAttribute('slide-slide'),
                slideLabel: '%s / %s',
            },
        };
        var splide = new Splide(splideElement, carouselCardSettings);

        // Remove arrows if only one slide
        splide.on('mounted', function () {
            const arrows = splideElement.querySelectorAll('.splide__arrow');

            if (splide.length === 1) {
                arrows.forEach((arrow) => (arrow.style.display = 'none'));
            }
        });
        splide.mount();

        let slideNumberElement = splideElement.querySelector('.slide_counter');

        // Shows the number of current slide and the total number of slides if more than one slide
        if (splide.length > 1) {
            slideNumberElement.innerHTML =
                splide.index + 1 + '/' + splide.length;

            splide.on('move', function () {
                var currentSlide = splide.index + 1;
                var totalSlides = splide.length;
                slideNumberElement.innerHTML = currentSlide + '/' + totalSlides;
            });
        } else {
            slideNumberElement.style.display = 'none';
        }
        // Update live region on slide change
        updateScreenReaderText(splide, splideElement);
    });
});
